"use strict";

jQuery(document).ready(function (jQuery) {
  if (document.querySelector('.quotes') !== null) {
    new Glider(document.querySelector('.quotes'), {
      dots: false,
      arrows: {
        prev: '.quote-slider-arrow-prev',
        next: '.quote-slider-arrow-next'
      },
      responsive: [{
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 375,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      }]
    });
  }
});